import { createApp } from 'vue'
import App from './App.vue'
import { initializeLocale } from './lib/i18n.mjs'
import router from './router'
import store from './store'

initializeLocale()
createApp(App).use(store).use(router).mount('#app')
